/** */
import React, { useEffect } from 'react';
// import cx from 'classnames';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import config from 'config';

/** */
import AccountActivation from './activation/activation';
import LoginForm from './login/login';
import PasswordRecovery from './password/recovery';
import PasswordReset from './password/reset';
import SignupForm from './signup/signup';

/** */
import styles from './guest.module.css';
// import { ReactComponent as Icon } from 'assets/icons/logo-sm.svg';
import PasswordResetSuccessful from './password/success';
import { useQuery } from 'app/hooks/query';
import { AgencySignupForm } from './signup/agency';

const GuestArea = () => {
  const params = useParams();
  const query = useQuery();
  const navigate = useNavigate();

  useEffect(() => {
    // Don't overwrite attribution data already captured in this session
    if (window.localStorage.getItem('utm')) return;

    // Ad-network click IDs and standard UTM params we care about
    const TRACKED_PARAMS = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
      'utm_id',
      'utm_creative',
      'utm_placement',
      // Google Ads
      'gclid',
      'gclsrc',
      'dclid',
      // Meta / Facebook
      'fbclid',
      // TikTok
      'ttclid',
      // Microsoft Ads
      'msclkid',
      // Twitter / X
      'twclid',
      // LinkedIn
      'li_fat_id',
      // Referral code
      'ref'
    ];

    // Collect whichever tracked params are present in the URL
    const params_from_url = TRACKED_PARAMS.reduce((acc, key) => {
      if (query[key]) acc[key] = query[key];
      return acc;
    }, {});

    // Enrich with browser-level signals
    const attribution = {
      ...params_from_url,
      referrer: document.referrer || null,
      landing_url: window.location.href,
      captured_at: new Date().toISOString()
    };

    // Only persist if there's at least one meaningful signal
    const has_signal = Object.keys(params_from_url).length > 0 || document.referrer;
    if (!has_signal) return;

    window.localStorage.setItem('utm', JSON.stringify(attribution));
  }, []);

  useEffect(() => {
    if (!params['*']) return;
    const [, path_two, token] = params['*'].split('/');
    if (path_two === 'acceptance') {
      window.localStorage.setItem('acceptance', token);
      navigate('register');
    }
  }, [params]);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={config.grecaptcha_key} useEnterpriseCaptcha>
      <div className={styles.wrapper}>
        <div className={styles.formWrapper}>
          <Routes>
            <Route path="login" element={<LoginForm />} />
            <Route path="register" element={<SignupForm />} />
            <Route path="agency/register" element={<AgencySignupForm />} />
            <Route path="activation/:id" element={<AccountActivation />} />
            <Route path="password/recovery/" element={<PasswordRecovery />} />
            <Route path="password/reset/:id" element={<PasswordReset />} />
            <Route path="password/success" element={<PasswordResetSuccessful />} />
            <Route path="/*" element={<LoginForm />} />
          </Routes>
        </div>
      </div>
    </GoogleReCaptchaProvider>
  );
};

export default GuestArea;
